module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bjwl')
    },
    model: {
      value: (_vm.showEdit),
      callback: function($$v) {
        _vm.showEdit = $$v
      },
      expression: "showEdit"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('lin_global.wllx')
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.wtype),
      callback: function($$v) {
        _vm.wtype = $$v
      },
      expression: "wtype"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwd')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.wtype),
      callback: function($$v) {
        _vm.wtype = $$v
      },
      expression: "wtype"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.city')))]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wtype == 1),
      expression: "wtype == 1"
    }],
    model: {
      value: (_vm.isProv),
      callback: function($$v) {
        _vm.isProv = $$v
      },
      expression: "isProv"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_onlyprov')))])], 1), _vm._v(" "), (_vm.wtype == 0) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_radius')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.form.radius),
      callback: function($$v) {
        _vm.$set(_vm.form, "radius", $$v)
      },
      expression: "form.radius"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweikm')))])], 2), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('lin_global.weilanshuoming')))])], 1) : _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.cityName')
    }
  }, [(!_vm.isProv) ? _c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.options2,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selEvent2
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }) : _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.selVl),
      callback: function($$v) {
        _vm.selVl = $$v
      },
      expression: "selVl"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showEdit = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.submit')))])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showEdit = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.bjwl')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.riskInfo.controlName))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('table', {
    attrs: {
      "id": "rsdtb"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wlmc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main",
    staticStyle: {
      "white-space": "nowrap",
      "text-overflow": "ellipsis",
      "max-width": "70%",
      "height": "14px",
      "overflow": "hidden",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.riskInfo.controlName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wllx')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskType[_vm.riskInfo.controlType]))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_city')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskInfo.city ? _vm.riskInfo.city.split(',')[0] : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "20px"
    }
  }, [_c('table', {
    attrs: {
      "id": "rsdtb"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_wldesc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskInfo.controlDesc))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.bdsb')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBind
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tjbd')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.batchUnBind
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.unbindAll')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "sortable": "custom",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "sortable": "custom",
      "label": _vm.$t('lin_global.label_no'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributorName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bindingtime",
      "sortable": "custom",
      "label": _vm.$t('terminal.appList.label_time'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.unbind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.unBind(scope.row.terminalid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain-broken",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bdsb')
    },
    on: {
      "close": _vm.closeBindAlert
    },
    model: {
      value: (_vm.dialogTopMgVisible),
      callback: function($$v) {
        _vm.dialogTopMgVisible = $$v
      },
      expression: "dialogTopMgVisible"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.tstVl),
      callback: function($$v) {
        _vm.tstVl = $$v
      },
      expression: "tstVl"
    }
  }, _vm._l((_vm.tstatus), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchBindRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.bindAll')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "2000px"
    },
    attrs: {
      "data": _vm.arrdata1,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.bind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.bindRow(scope.row.terminalId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "right",
      "margin-bottom": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage1,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize1,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords1
    },
    on: {
      "size-change": _vm.handleSizeChange1,
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333932bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/risk/detail.vue
// module id = 1005
// module chunks = 0